import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const JsonViewer = ({ data, defaultExpanded = false }: { data: any; defaultExpanded?: boolean }) => {
    return (
        <>
            <Accordion defaultExpanded={defaultExpanded} TransitionProps={{ unmountOnExit: true }} sx={{}}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                >
                    <Typography fontWeight={600}>JSON Viewer</Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ overflow: "auto", maxHeight: "80vh" }}>
                    <div>
                        {data ? (
                            <pre>{JSON.stringify(data, null, 2)}</pre>
                        ) : (
                            <Typography>Loading data...</Typography>
                        )}
                    </div>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default JsonViewer